import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, useTheme, tableCellClasses, styled } from '@mui/material';


import Run from '../../types/run';
import Game, { GameStreaks, Streak } from '../../types/game';
import { groupBy, stringDateToDate } from '../../utils/utils';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const calculateStreaksPerGame = (runs: Run[], games: Game[]) => {
  const groupedRuns = groupBy(runs as [], 'selectedGame') as [];
  const streaks: GameStreaks[] = [];
  games.forEach((game, index) => {
    const currentGameRuns: Run[] = groupedRuns[index];
    let emptyStreak: Streak = { streakNumber: 0, initialDate: runs[0]?.date || '', endDate: runs[0]?.date };
    let winStreak = 0;
    let loseStreak = 0;
    let biggestWinStreak = 0;
    let biggestLoseStreak = 0;
    if(!currentGameRuns || currentGameRuns?.length === 0) {
      streaks.push({ game: game, winStreak: emptyStreak, loseStreak: emptyStreak });
      return;
    }
    let startLoseStreakDate = currentGameRuns[0].date;
    let startWinStreakDate = currentGameRuns[0].date;
    let endedLoseStreakDate = currentGameRuns[0].date;
    let endedWinStreakDate = currentGameRuns[0].date;

    currentGameRuns.forEach((run, index) => {
      if(run.includesHit) {
        winStreak = 0;
        loseStreak += 1;
        if(loseStreak > biggestLoseStreak) {
          biggestLoseStreak = loseStreak;
          startLoseStreakDate = currentGameRuns[index - loseStreak]?.date || runs[0].date;
          endedLoseStreakDate = run.date;
        }
      } else {
        loseStreak = 0;
        winStreak += 1;
        if(winStreak > biggestWinStreak) {
          biggestWinStreak = winStreak;
          startWinStreakDate = currentGameRuns[index - winStreak]?.date || runs[0].date;
          endedWinStreakDate = run.date;
        }
        biggestWinStreak = winStreak > biggestWinStreak ? winStreak : biggestWinStreak;
      }
    });
    streaks.push({ game: game, winStreak: { streakNumber: biggestWinStreak, initialDate: startWinStreakDate, endDate: endedWinStreakDate }, loseStreak: { streakNumber: biggestLoseStreak, initialDate: startLoseStreakDate, endDate: endedLoseStreakDate } });
  });
  return streaks;
};


function StreakTable({ runs, games }: { runs: Run[], games: Game[] }) {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));
  const streaks = calculateStreaksPerGame(runs, games);
  return (
    <>
      <TableContainer sx={{ minWidth: isMobile ? 330 : 500 }} component={Paper}>
        <Table aria-label="simple table" size={'small'}>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold' }} colSpan={1}>Game</StyledTableCell>
              <StyledTableCell sx={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold' }} colSpan={1}>No Hit Streak</StyledTableCell>
              <StyledTableCell sx={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold' }} colSpan={1}>Hit Streak</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {games.map((game, index) => {
              return (
                <TableRow
                  key={game.id}
                  sx={{ '&:last-child td': { border: 0 }, fontSize: 20 }}
                >
                  <TableCell sx={{ fontSize: 20 }} scope="row">
                    {game.name}
                  </TableCell>
                  <TableCell sx={{ fontSize: 20 }} component="td" scope="row">
                    {streaks[index].winStreak.streakNumber} (from {stringDateToDate(streaks[index].winStreak.initialDate).toLocaleDateString()} to {stringDateToDate(streaks[index].winStreak.endDate).toLocaleDateString()})
                  </TableCell>
                  <TableCell sx={{ fontSize: 20 }} component="td" scope="row">
                      {streaks[index].loseStreak.streakNumber} (from {stringDateToDate(streaks[index].loseStreak.initialDate).toLocaleDateString()} to {stringDateToDate(streaks[index].loseStreak.endDate).toLocaleDateString()})
                  </TableCell>
                </TableRow>
              );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
    
  );
}

export default StreakTable;